export enum AppsConstraints {
  DASHBOARD = "DASHBOARD",
  CALL_CENTER = "CALL_CENTER",
  OOC = "OOC",
  ERROR = "ERROR",
  CALLCENTER = "CALL-CENTER",
}

export enum MODES {
  SUMMARY = "summary",
  FULL = "full",
  WITH_TAGS = "with_tags",
  LIST = "list",
}

export enum FORM_TYPE {
  CREATE = "CREATE",
  EDIT = "EDIT",
  PREVIEW = "PREVIEW",
}

export enum NAV_BADGE {
  CHART_NOTIFICATION_BADGE = "CHART_NOTIFICATION_BADGE",
}

export enum TABLE_SORT {
  true = "-",
  false = "",
}
